var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"36","height":"36","viewBox":"0 0 36 36"}},[_c('path',{style:({ fill: _vm.colorSVG }),attrs:{"data-name":"合体 269","d":"m21 18.006 8.24-7.326a2.229 2.229 0 0 0 0-3.35L21 0zm-7-18v18h4v-18zm-7 0v18h4v-18zm-7 0v18h4v-18z","transform":"rotate(180 16.5 13.501)"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }